module.exports = __webpack_public_path__ + "static/app/img/1.aec58e5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/1.png
// module id = FF/J
// module chunks = 1